import { EcardWrapper } from './EcardWrapper';
export default EcardWrapper;
